/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SetupTask, SetupTask$inboundSchema } from "./setuptask.js";

export type ListSetupTasksResult = {
  /**
   * Setup tasks in catalog order. A group precedes the cards under it.
   */
  tasks: Array<SetupTask>;
};

/** @internal */
export const ListSetupTasksResult$inboundSchema: z.ZodMiniType<
  ListSetupTasksResult,
  unknown
> = z.object({
  tasks: z.array(SetupTask$inboundSchema),
});

export function listSetupTasksResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSetupTasksResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSetupTasksResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSetupTasksResult' from JSON`,
  );
}
